import { create } from 'zustand';
import { serviceAPI } from '../services/api';
import { Service } from '@shared/types';

interface ServiceStoreState {
  services: Service[];
  isLoading: boolean;
  fetchServices: () => Promise<void>;
  loadServices: (language: string) => Promise<void>;
  getServiceBySlug: (slug: string) => Service | undefined;
}

export const useServiceStore = create<ServiceStoreState>((set, get) => ({
  services: [],
  isLoading: false,
  fetchServices: async () => {
    const { services, isLoading } = get();

    // Prevent concurrent fetches or refetching if data exists
    if (isLoading || services.length > 0) {
      return;
    }

    set({ isLoading: true });

    try {
      const response = await serviceAPI.getAll();
      set({ services: response.data, isLoading: false });
    } catch (error) {
      console.error('Failed to fetch services:', error);
      set({ isLoading: false });
    }
  },
  loadServices: async (_language: string) => {
    // Determine if we need to pass language to API in the future.
    // Currently, getAll returns all data, so we just use the cached fetcher.
    await get().fetchServices();
  },
  getServiceBySlug: (slug: string) => {
    return get().services.find(service => service.slug === slug);
  },
}));
